
export default "/assets/shopping-bag-micro.06183a06.svg"